import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class AvatarAPI extends ComponentAPI {
    setTitle(title) {
        this.setState({ title });
    }
    getTitle() {
        return this.state.title;
    }
    setSubtitle(subtitle) {
        this.setState({ subtitle });
    }
    getSubtitle() {
        return this.state.subtitle;
    }
    setSubtitlesHiddenOnMobile(subtitleHiddenOnMobile) {
        this.setState({ subtitleHiddenOnMobile });
    }
    isSubtitlesHiddenOnMobile() {
        return this.state.subtitleHiddenOnMobile;
    }
    setHideImage(hideImage) {
        this.setState({ hideImage });
    }
    shouldHideImage() {
        return this.state.hideImage;
    }
    setImage(image) {
        this.setState({ image });
    }
    getImage() {
        return this.state.image;
    }
    setSize(size) {
        this.setState({ size });
    }
    getSize() {
        return this.state.size;
    }
    setDirection(direction) {
        this.setState({ direction });
    }
    getDirection() {
        return this.state.direction;
    }
    setShowImageBorder(showImageBorder) {
        this.setState({ showImageBorder });
    }
    getImageBorder() {
        return this.state.showImageBorder;
    }
}
export default AvatarAPI;
//# sourceMappingURL=avatar-api.js.map